<template>
    <layout :showuserinfo="false">
        <div class="container-fluid" style="min-height: 500px;">
            <div class="page-wrapper-portal">
                <MenuNav />
                <template v-if="$zutil.pwaMobile() == 1">
                    <div class="card card-pkn mt3">

                        <Menu :auth="auth" :link="'carian'" />

                        <template v-if="currentStep === 1">
                            <div class="card-body bg-white card-scroll">


                                <!-- -->
                                <div class="row">
                                    <div class="col-lg-12 mb4 row ">
                                        <w-alert class="my0 mb2 text-light" v-if="errors" error transition="bounce" plain
                                            round no-border dismiss>
                                            {{ errors.replace('%20', ' ').replace('%20', ' ').replace('%20', ' ').replace('%20',' ').replace('%20', ' ').replace('%20', ' ').replace('%20', ' ').replace('%20', '').replace('%20', ' ')}}
                                        </w-alert>

                                        <div class="col-12 " v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                            <div class="row align-items-center">
                                                <div class="col">

                                                    <div class="input-group ">
                                                        <input type="text" class="form-control "
                                                            placeholder="Sila Masukkan No. Hak Milik / No. Akaun / No. Bil "
                                                            aria-label="Recipient's username"
                                                            aria-describedby="button-addon2" v-model="no_rujukan">
                                                        <template v-if="loading == 0">
                                                            <template
                                                                v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                                <button class="btn btn-pkn" type="button"
                                                                    @click="carian(0)">Cari <!-- dan Tambah Bil --></button>
                                                            </template>
                                                            <template v-else>
                                                                <button class="btn btn-pkn" type="button"
                                                                    @click="carian(0)">Cari dan Tambah Bil</button>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <button class="btn btn-pkn" type="button">Mencari..</button>
                                                        </template>
                                                    </div>



                                                </div><!--end col-->


                                            </div>
                                        </div>
                                        <div class="col-6" v-else>
                                            <div class="row align-items-center">
                                                <div class="col">

                                                    <div class="input-group ">
                                                        <input type="text" class="form-control "
                                                            placeholder="Sila Masukkan No. Hak Milik / No. Akaun / No. Bil "
                                                            aria-label="Recipient's username"
                                                            aria-describedby="button-addon2" v-model="no_rujukan">
                                                        <template v-if="loading == 0">
                                                            <template
                                                                v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                                <button class="btn btn-pkn" type="button"
                                                                    @click="carian(0)">Cari <!-- dan Tambah Bil --></button>
                                                            </template>
                                                            <template v-else>
                                                                <button class="btn btn-pkn" type="button"
                                                                    @click="carian(0)">Cari dan Tambah Bil</button>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <button class="btn btn-pkn" type="button">Mencari..</button>
                                                        </template>
                                                    </div>



                                                </div><!--end col-->


                                            </div>
                                        </div> <!--end row-->
                                        <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                            <div class="col-12 text-center mt-3">
                                                <button class="btn btn-pkn " type="button" @click="carianCukai()">Carian
                                                    Cukai
                                                    Terperinci</button>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col-6 ">
                                                <button class="btn btn-pkn " type="button" @click="carianCukai()">Carian
                                                    Cukai
                                                    Terperinci</button>
                                            </div>
                                        </template>
                                    </div>
                                    <template v-if="cari.no_rujukan && butirans.length == 0">
                                        <center>
                                            <h5>Rekod Tidak dijumpai.</h5>
                                        </center>
                                    </template>
                                    <template v-if="butirans.length > 0">
                                        <div class="col-lg-9">
                                            <div class="row justify-content-center">

                                                <div class="card-body">
                                                    <div class="col-lg-12">
                                                        <div class="card">
                                                            <div class="card-header">
                                                                <h4 class="card-title"><b class="text-primary">1.</b>
                                                                    Senarai
                                                                    Hasil Carian</h4>
                                                            </div><!--end card-header-->
                                                            <div class="card-body">

                                                                <template
                                                                    v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                                    <template v-for="dt, index in butirans">
                                                                        <div class="card" v-if="dt.bakul == 0">
                                                                            <div class="card-header text-light bg-dark">
                                                                                <div class="fw-semibold m0">
                                                                                    {{ dt.sumber_keterangan }}</div>
                                                                            </div>
                                                                            <div class="card-body">
                                                                                <div class="row">
                                                                                    <div class="col-12">
                                                                                        <div class="fw-normal ">
                                                                                            {{ dt.no_rujukan }} |
                                                                                            {{ dt.keterangan }}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-xs-12">
                                                                                        <div class="fw-normal ">
                                                                                            <b>Amaun Perlu Bayar
                                                                                                : RM</b>{{
                                                                                                    $zutil.currency(dt.amaun) }}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-xs-12">

                                                                                        <div class="fw-normal float-right">

                                                                                            <template
                                                                                                v-if="dt.detail.flag_halangan_id">
                                                                                                <span class="text-red">{{
                                                                                                    dt.detail.halangan
                                                                                                }}</span>

                                                                                            </template>
                                                                                            <template v-else>
                                                                                                <template
                                                                                                    v-if="dt.lkp_sumber_id != 9">
                                                                                                    <div class="btn-pkn-1"
                                                                                                        @click="pilih(dt, 1)"
                                                                                                        v-if="dt.amaun > 0">
                                                                                                        <i
                                                                                                            class="dripicons-cart"></i>
                                                                                                    </div>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <template
                                                                                                        v-if="dt.detail.belum_bayar == 1">
                                                                                                        <div class="btn-pkn-1"
                                                                                                            @click="pilih(dt, 1)"
                                                                                                            v-if="dt.amaun > 0">
                                                                                                            <i
                                                                                                                class="dripicons-cart"></i>
                                                                                                        </div>
                                                                                                    </template>
                                                                                                    <template v-else>
                                                                                                        <b>Sudah Bayar</b>
                                                                                                    </template>
                                                                                                </template>
                                                                                            </template>

                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>



                                                                        </div><br />
                                                                    </template>
                                                                    <div class="card bg-light p-2" v-if="total_carian">
                                                                        <w-flex>
                                                                            <div class="xs6">
                                                                                <div class="fw-semibold m0"> JUMLAH</div>

                                                                            </div>
                                                                            <div class="xs6 ">

                                                                                <div class="fw-normal float-right">
                                                                                    <strong>{{ $zutil.currency(total_carian)
                                                                                    }}
                                                                                    </strong>
                                                                                </div>
                                                                            </div>
                                                                        </w-flex>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <div class="table-responsive shopping-cart">

                                                                        <table class="table mb-0">
                                                                            <thead>
                                                                                <tr>

                                                                                    <th class="border-top-0">Jenis
                                                                                        Pembayaran
                                                                                    </th>
                                                                                    <th>No. Rujukan | Nama </th>
                                                                                    <th class="border-top-0 text-right">
                                                                                        Amaun
                                                                                        Perlu Bayar (RM)</th>
                                                                                    <th></th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <template v-for="dt, index in butirans">
                                                                                    <template v-if="dt.bakul == 0">
                                                                                        <tr>
                                                                                            <td>
                                                                                                {{ dt.sumber_keterangan }}
                                                                                            </td>

                                                                                            <td>{{ dt.no_rujukan }} |
                                                                                                {{ dt.keterangan }}</td>
                                                                                            <td class="text-right">
                                                                                                {{ $zutil.currency(dt.amaun)
                                                                                                }}
                                                                                            </td>
                                                                                            <td width="1%">
                                                                                                <template
                                                                                                    v-if="dt.detail.flag_halangan_id">
                                                                                                    {{ dt.detail.halangan }}

                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <template
                                                                                                        v-if="dt.lkp_sumber_id != 9">
                                                                                                        <div class="btn-pkn-1"
                                                                                                            @click="pilih(dt, 1)"
                                                                                                            v-if="dt.amaun > 0">
                                                                                                            Tambah <i
                                                                                                                class="dripicons-cart"></i>
                                                                                                        </div>
                                                                                                    </template>
                                                                                                    <template v-else>
                                                                                                        <template
                                                                                                            v-if="dt.detail.belum_bayar == 1">
                                                                                                            <div class="btn-pkn-1"
                                                                                                                @click="pilih(dt, 1)"
                                                                                                                v-if="dt.amaun > 0">
                                                                                                                Tambah <i
                                                                                                                    class="dripicons-cart"></i>
                                                                                                            </div>
                                                                                                        </template>
                                                                                                        <template v-else>
                                                                                                            <b>Sudah
                                                                                                                Bayar</b>
                                                                                                        </template>
                                                                                                    </template>
                                                                                                </template>
                                                                                            </td>
                                                                                            <td width="1%">
                                                                                                <template
                                                                                                    v-if="dt.lkp_sumber_id == 1">

                                                                                                    <div class="btn-pkn-1">
                                                                                                        <a :href="dt.url"
                                                                                                            target="_blank"
                                                                                                            class="btn-pkn-3">
                                                                                                            Cetak <i
                                                                                                                class="dripicons-print ml1"></i>
                                                                                                        </a>
                                                                                                    </div>

                                                                                                </template>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template></template>
                                                                                <tr>

                                                                                    <td>
                                                                                        <h6>Jumlah :</h6>
                                                                                    </td>
                                                                                    <td></td>
                                                                                    <td class="text-dark text-right">
                                                                                        <strong>{{
                                                                                            $zutil.currency(total_carian) }}
                                                                                        </strong>
                                                                                    </td>
                                                                                    <td></td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>


                                                                    </div>
                                                                </template>

                                                            </div><!--end card-body-->
                                                        </div>
                                                    </div><!--end col-->

                                                    <div class="col-lg-12 mt4">
                                                        <div class="card" v-if="bakul_ind">
                                                            <div class="card-header">
                                                                <h4 class="card-title"><b class="text-primary">2.</b>
                                                                    Senarai
                                                                    Yang Ingin Dibayar</h4>
                                                            </div><!--end card-header-->
                                                            <div class="card-body ">
                                                                <template
                                                                    v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                                    <template v-for="dt, index in butirans">
                                                                        <div class="card border-0" v-if="dt.bakul == 1">

                                                                            <w-flex>
                                                                                <div class="xs6">
                                                                                    <div class="fw-semibold m0">
                                                                                        {{ dt.sumber_keterangan }}</div>
                                                                                    <div class="fw-normal ">
                                                                                        {{ dt.no_rujukan }} | {{
                                                                                            dt.keterangan }}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="xs6 text-right">

                                                                                    <div class="fw-normal ">
                                                                                        <b>Perlu Bayar :</b><br>
                                                                                        {{ $zutil.currency(dt.amaun) }}
                                                                                    </div>
                                                                                    <div class="fw-normal ">

                                                                                        <b> Bayar :</b> <br>
                                                                                        <template
                                                                                            v-if="dt.lkp_sumber_id == 1 || dt.lkp_sumber_id == 9 || dt.lkp_sumber_id == 11">
                                                                                            {{
                                                                                                $zutil.currency(dt.amaun_bayar)
                                                                                            }}
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <z-money
                                                                                                :validators="[validators.required]"
                                                                                                v-model:originalValue="dt.amaun_bayar"
                                                                                                v-on:keyup="checkAmaun(dt)"
                                                                                                v-on:change="pilih(dt, 1)" />
                                                                                            <span
                                                                                                class="tw-form-el__error error">{{
                                                                                                    dt.mesej }}</span>
                                                                                        </template>
                                                                                    </div>
                                                                                    <div class="fw-normal float-right">
                                                                                        <div class="btn-pkn-2"
                                                                                            @click="pilih(dt, 0)">
                                                                                            <i class="dripicons-trash"></i>
                                                                                        </div>

                                                                                    </div>

                                                                                </div>
                                                                            </w-flex>
                                                                        </div>
                                                                    </template>
                                                                    <div class="card bg-light" v-if="total_pilih">
                                                                        <w-flex>
                                                                            <div class="xs6">
                                                                                <div class="fw-semibold m0"> JUMLAH</div>

                                                                            </div>
                                                                            <div class="xs6 ">

                                                                                <div class="fw-normal float-right">
                                                                                    <strong>{{ $zutil.currency(total_pilih)
                                                                                    }}
                                                                                    </strong>
                                                                                </div>
                                                                            </div>
                                                                        </w-flex>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <div class="table-responsive shopping-cart">
                                                                        <table class="table mb-0">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th class="border-top-0" rowspan="2">
                                                                                        Jenis
                                                                                        Pembayaran</th>
                                                                                    <th rowspan="2">No. Rujukan | Nama</th>
                                                                                    <th class="border-top-0 text-center"
                                                                                        colspan="2">Amaun (RM)</th>
                                                                                    <th rowspan="2"></th>
                                                                                    <th rowspan="2"></th>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th class="border-top-0 text-center">
                                                                                        Perlu
                                                                                        Bayar</th>
                                                                                    <th class="border-top-0 text-center">
                                                                                        Bayar
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <template v-for="dt, index in butirans">
                                                                                    <template v-if="dt.bakul == 1">
                                                                                        <tr>
                                                                                            <td>
                                                                                                {{ dt.sumber_keterangan }}
                                                                                            </td>
                                                                                            <td>
                                                                                                {{ dt.no_rujukan }} |
                                                                                                {{ dt.keterangan }}</td>
                                                                                            <td class="text-right">
                                                                                                {{ $zutil.currency(dt.amaun)
                                                                                                }}
                                                                                            </td>
                                                                                            <td class="text-right">
                                                                                                <template
                                                                                                    v-if="dt.lkp_sumber_id == 1 || dt.lkp_sumber_id == 9 || dt.lkp_sumber_id == 11">
                                                                                                    {{
                                                                                                        $zutil.currency(dt.amaun_bayar)
                                                                                                    }}
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <z-money
                                                                                                        :validators="[validators.required]"
                                                                                                        v-model:originalValue="dt.amaun_bayar"
                                                                                                        v-on:keyup="checkAmaun(dt)"
                                                                                                        v-on:change="pilih(dt, 1)" />
                                                                                                    <span
                                                                                                        class="tw-form-el__error error">{{
                                                                                                            dt.mesej }}</span>
                                                                                                </template>
                                                                                            </td>
                                                                                            <td width="1%">

                                                                                                <div class="btn-pkn-2"
                                                                                                    @click="pilih(dt, 0)">
                                                                                                    Padam <i
                                                                                                        class="dripicons-trash"></i>
                                                                                                </div>

                                                                                            </td>
                                                                                            <td width="1%">

                                                                                                <template
                                                                                                    v-if="dt.lkp_sumber_id == 1">
                                                                                                    <div class="btn-pkn-1">
                                                                                                        <a :href="dt.url"
                                                                                                            target="_blank"
                                                                                                            class="btn-pkn-3">
                                                                                                            Cetak <i
                                                                                                                class="dripicons-print ml1"></i>
                                                                                                        </a>
                                                                                                    </div>
                                                                                                </template>

                                                                                            </td>
                                                                                        </tr>
                                                                                    </template>

                                                                                </template>

                                                                                <tr>

                                                                                    <td>
                                                                                        <h6>Jumlah :</h6>
                                                                                    </td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td class="text-dark text-right">
                                                                                        <strong>{{
                                                                                            $zutil.currency(total_pilih) }}
                                                                                        </strong>
                                                                                    </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>



                                                                    </div>
                                                                </template>
                                                            </div><!--end card-body-->

                                                        </div>
                                                    </div><!--end col-->

                                                    <div class="col-lg-12" v-if="auth.user.id == 0">

                                                        <w-form class="" v-model="form.valid"
                                                            v-model:errors-count="form.errorsCount" @validate="onValidate"
                                                            @success="simpanProfil()">
                                                            <div class="card" v-if="total_pilih">
                                                                <div class="card-header">
                                                                    <h4 class="card-title"><b class="text-primary">3.</b>
                                                                        Profil
                                                                        Pembayar</h4>
                                                                    <!-- <p class="text-muted mb-0">Sila Pastikan maklumat dibawah adalah benar dan tepat.</p> -->
                                                                </div><!--end card-header-->
                                                                <div class="card-body">
                                                                    <w-flex class="mt2">
                                                                        <div class="xs6 mr5">
                                                                            <w-input v-model="form.nama" required
                                                                                label="Nama *"
                                                                                :validators="[validators.required]" />
                                                                        </div>
                                                                        <div class="xs6">
                                                                            <w-input v-model="form.no_id" required
                                                                                label="No. KP / Pasport / Syarikat *"
                                                                                :validators="[validators.required]" />
                                                                        </div>
                                                                    </w-flex>
                                                                    <w-flex class="mt2">
                                                                        <div class="xs6 mr5">
                                                                            <w-input v-model="form.emel" required
                                                                                label="Emel *"
                                                                                :validators="[validators.required, validators.email]" />
                                                                        </div>
                                                                        <div class="xs6">
                                                                            <w-input v-model="form.no_tel" required
                                                                                label="No Tel *"
                                                                                :validators="[validators.required]" />
                                                                        </div>
                                                                    </w-flex>
                                                                    <w-flex class="mt2">
                                                                        <div class="xs12 mr5">
                                                                            <w-textarea v-model="form.alamat1"
                                                                                :validators="[validators.required]">Alamat
                                                                                *</w-textarea>
                                                                        </div>
                                                                    </w-flex>

                                                                    <!-- <w-button class="my1" @click="caraBayar()" > Teruskan</w-button> -->
                                                                    <w-button class="my1" type="submit"
                                                                        :disabled="form.valid === false"
                                                                        :loading="form.submitted && !form.sent">
                                                                        Teruskan</w-button>


                                                                </div><!--end card-body-->
                                                            </div>
                                                        </w-form>
                                                    </div><!--end col-->


                                                    <!-- -->




                                                </div> <!--end col-->

                                                <!-- -->

                                            </div><!--end row-->

                                        </div><!--end col-->


                                    </template>
                                </div><!--end row-->
                                <!-- -->

                            </div><!--end card-body-->
                            <template v-if="total_pilih">
                                <div class="card-footer">
                                    <button class="btn btn-primary" @click="prevStep"
                                        v-if="currentStep > 1">Kembali</button>
                                    <button class="btn btn-dark" @click="authenticate">Seterusnya</button>

                                </div>
                            </template>

                            <w-dialog title="Pengesahan Kata Laluan" v-model="dialog_authenticate.show"
                                :fullscreen="dialog_authenticate.fullscreen" :width="dialog_authenticate.width"
                                :persistent="dialog_authenticate.persistent"
                                :persistent-no-animation="dialog_authenticate.persistentNoAnimation">

                                <div class="page-wrapper-portal">

                                    <div class="pkn-contact">
                                        <div>
                                            <input class="form-control" type="password" v-model="password"
                                                placeholder="Enter password" />
                                        </div>
                                        <button class="btn btn-primary mt1" @click="checkPassword">Semak Kata Kunci</button>
                                        <div v-if="passwordMatch == true">
                                            Kata Kunci Sepadan
                                        </div>
                                        <div v-else-if="passwordMatch != true">
                                            Kata Kunci Tidak Sepadan
                                        </div>




                                    </div>
                                </div>
                                <template #actions>
                                    <div class="spacer" />
                                    <button class="btn btn-danger mr1" bg-color="grey-light5--bg"
                                        @click="dialog_authenticate.show = false">Tutup</button>
                                    <template v-if="passwordMatch == true">

                                        <button class="btn btn-dark" @click="nextStep"
                                            v-if="currentStep < totalSteps">Seterusnya</button>
                                    </template>


                                </template>

                            </w-dialog>
                        </template>
                        <template v-if="currentStep === 2">
                            <div class="card-body card-scroll">
                                <div class="col-lg-3">



                                    <div class="card mb4" v-if="total_pilih && cara_bayar">
                                        <div class="card-header">
                                            <h4 class="card-title"> <b class="text-primary">
                                                    <template v-if="auth.user.id == 0">4.</template>
                                                    <template v-else>3.</template>
                                                </b> Cara Pembayaran</h4>
                                        </div><!--end card-header-->
                                        <div class="card-body">
                                            <div class="d-flex">
                                                <div class="d-block ms-2 align-self-center">


                                                </div>
                                            </div>
                                            <div class="accordion accordion-flush checkout-accordion"
                                                id="accordionFlushExample">

                                                <!-- <div class="accordion-item" v-if="total_pilih <= 30000 && total_pilih >= 1"> -->
                                               <!--  <div class="accordion-item" v-if="total_pilih >= 1">
                                                    <h2 class="accordion-header mt-0" id="flush-headingTwo">
                                                        <button class="accordion-button collapsed d-flex " type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo"
                                                            aria-expanded="false" aria-controls="flush-collapseTwo"
                                                            @click="pilihCaraTerima(1)" >
                                                            <img src="assets/images/cards/card-10.svg" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">FPX</span>
                                                            &nbsp;&nbsp;&nbsp;<h2><i class="dripicons-checkmark"
                                                                    v-if="form.lkp_cara_terima_id == 1"></i></h2>
                                                        </button>

                                                    </h2>

                                                </div> -->
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header mt-0" id="flush-headingOne">
                                                        <button class="accordion-button collapsed d-flex " type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo"
                                                            aria-expanded="false" aria-controls="flush-collapseTwo"
                                                            @click="pilihCaraTerima(2)">
                                                            <img src="assets/images/cards/card-2.png" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">Kad
                                                                Kredit</span> &nbsp;&nbsp;&nbsp;<h2><i
                                                                    class="dripicons-checkmark"
                                                                    v-if="form.lkp_cara_terima_id == 2"></i></h2>
                                                        </button>
                                                    </h2>

                                                </div>

                                            </div>

                                            <div class="mb4 mt2"><b>Pengumuman :</b></div>

                                            <div class="mb4">
                                                Cara pembayaran melalui eWallet akan dapat dilakukan di iBayaq dalam
                                                masa terdekat.
                                            </div>
                                            <!-- <div class="mb2">
                                                    Mohon Maaf, Cara Pembayaran melalui FPX tergendala buat masa kini. Harap maklum.
                                                </div> -->

                                            Sekian, Terima Kasih

                                        </div><!--end card-body-->

                                    </div>
                                    <!-- <div class="card mb4" v-if="total_pilih &&  cara_bayar">
                                        <div class="card-body">
                                       <div class="mb3"><b>Had limit kadar bayaran FPX :</b></div>
                                           <div class="card-scroll">
                                               <div class="px-3 py-3">
                                                   <table border="0" cellpadding="1" cellspacing="1" style="width:100%">
                                                      <tbody>
                                                         <tr>
                                                            <td width="32%">Maksimum</td>
                                                            <td style="text-align: center;" width="32%">B2B</td>
                                                            <td style="text-align: right;" width="36%">RM 1,000,000</td>
                                                         </tr>
                                                         <tr>
                                                            <td>Minimum</td>
                                                            <td style="text-align: center;">B2B</td>
                                                            <td style="text-align: right;">RM 2.00</td>
                                                         </tr>
                                                         <tr>
                                                            <td>Maksimum</td>
                                                            <td style="text-align: center;">B2C</td>
                                                            <td style="text-align: right;">RM 30,000</td>
                                                         </tr>
                                                         <tr>
                                                            <td>Minimum</td>
                                                            <td style="text-align: center;">B2C</td>
                                                            <td style="text-align: right;">RM 1.00</td>
                                                         </tr>
                                                      </tbody>
                                                   </table>
                                               </div>
                                           </div>
                                                </div>       
                                            </div>     -->



                                </div> <!--end col-->
                            </div>
                            <div class="card-footer">
                                <button class="btn btn-primary mx-1" @click="prevStep"
                                    v-if="currentStep > 1">Kembali</button>
                                <template v-if="total_pilih && cara_bayar && form.lkp_cara_terima_id != 0">
                                    <button class="btn btn-dark" @click="nextStep"
                                        v-if="currentStep < totalSteps">Seterusnya</button>
                                </template>
                            </div>
                        </template>
                        <template v-if="currentStep === 3">

                            <div class="card-body bg-light">
                                <div class="card" v-if="total_pilih && cara_bayar">


                                    <div class="card-header">
                                        <h4 class="card-title"> <b class="text-primary">4.</b> Terma & Syarat</h4>
                                    </div><!--end card-header-->
                                    <div class="card-body">
                                        Disini saya mengesahkan bahawa saya memperakui segala terma dan syarat yang
                                        telah ditetapkan oleh pihak kerajaan kedah melalui platform iBayaq
                                        <br>
                                        <w-checkbox class="mt3 mb3" v-model="form.agree">Setuju terima dan
                                            syarat</w-checkbox> <br>
                                        <!-- {{form.agree}} |{{form.lkp_cara_terima_id}}|{{form.check_amaun}}|{{data_profil.no_id}} -->
                                        <template
                                            v-if="form.agree == true && form.lkp_cara_terima_id != 0 && form.check_amaun != 0 && data_profil.no_id">
                                            <!-- <form action="http://pg.lokal.my/pay/proceed" method="post"> -->
                                            <form :action="url_payment" method="post">
                                                <input type="hidden" name="flow" value="01">
                                                <input type="hidden" name="api" value="1">
                                                <input type="hidden" name="token" value="1234">
                                                <input type="hidden" name="method" v-model="form.lkp_cara_terima_id">
                                                <input type="hidden" name="id" v-model="troli.id">
                                                <input type="hidden" name="return_url" v-model="url_return">
                                                <input type="hidden" name="callback_url" v-model="url_callback">
                                                <input type="hidden" name="amount" v-model="total_pilih">
                                                <input type="hidden" name="profil_id" v-model="data_profil.id">
                                                <input type="hidden" name="name" v-model="data_profil.nama">
                                                <input type="hidden" name="email" v-model="data_profil.emel">
                                                <input type="hidden" name="mobile" v-model="data_profil.no_tel">
                                                <input type="hidden" name="description" value="Bayaran iBayaq">
                                                <template v-for="dt, index in butirans">
                                                    <template v-if="dt.bakul == 1">

                                                        <input type="hidden" name="troli_detail_id[]" v-model="dt.id">
                                                        <input type="hidden" name="troli_detail_amaun_bayar[]"
                                                            v-model="dt.amaun_bayar">
                                                    </template>
                                                </template>
                                                <!-- <button type="submit">Bayar</button> -->
                                                <button class="btn btn-primary my1 mx-1" @click="prevStep"
                                                    v-if="currentStep > 1">Kembali</button>

                                                <button class="btn my1 text-white" type="submit"
                                                    :disabled="form.valid === false" style="background-color: #fb0001;">Bayar </button>
                                            </form>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-primary mx-1 my1" @click="prevStep"
                                                v-if="currentStep > 1">Kembali</button>
                                        </template>

                                    </div><!--end card-body-->

                                </div>

                            </div>
                        </template>



                    </div>

                </template>
                <template v-else>
                    <div class="card card-pkn">

                        <Menu :auth="auth" :link="'carian'" />

                        <div class="card-body card-scroll">

                            <!-- -->
                            <div class="row">
                                <div class="col-lg-12 mb4 row">
                                    <w-alert class="my0 mb2 text-light" v-if="errors" error transition="bounce" plain round
                                        no-border dismiss>
                                        {{ errors.replace('%20', ' ').replace('%20', ' ').replace('%20', ' ').replace('%20',' ').replace('%20', ' ').replace('%20', ' ').replace('%20', '  ').replace('%20', '').replace('%20', ' ')}}
                                    </w-alert>

                                    <div class="col-12" v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                        <div class="row align-items-center">
                                            <div class="col">

                                                <div class="input-group ">
                                                    <input type="text" class="form-control "
                                                        placeholder="Sila Masukkan No. Hak Milik / No. Akaun / No. Bil "
                                                        aria-label="Recipient's username" aria-describedby="button-addon2"
                                                        v-model="no_rujukan">
                                                    <template v-if="loading == 0">
                                                        <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                            <button class="btn btn-pkn" type="button"
                                                                @click="carian(0)">Cari <!-- dan Tambah Bil --></button>
                                                        </template>
                                                        <template v-else>
                                                            <button class="btn btn-pkn" type="button"
                                                                @click="carian(0)">Cari dan Tambah Bil</button>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <button class="btn btn-pkn" type="button">Mencari..</button>
                                                    </template>
                                                </div>



                                            </div><!--end col-->


                                        </div>
                                    </div>
                                    <div class="col-6" v-else>
                                        <div class="row align-items-center">
                                            <div class="col">

                                                <div class="input-group ">
                                                    <input type="text" class="form-control "
                                                        placeholder="Sila Masukkan No. Hak Milik / No. Akaun / No. Bil "
                                                        aria-label="Recipient's username" aria-describedby="button-addon2"
                                                        v-model="no_rujukan">
                                                    <template v-if="loading == 0">
                                                        <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                            <button class="btn btn-pkn" type="button"
                                                                @click="carian(0)">Cari <!-- dan Tambah Bil --></button>
                                                        </template>
                                                        <template v-else>
                                                            <button class="btn btn-pkn" type="button"
                                                                @click="carian(0)">Cari dan Tambah Bil</button>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <button class="btn btn-pkn" type="button">Mencari..</button>
                                                    </template>
                                                </div>



                                            </div><!--end col-->


                                        </div>
                                    </div> <!--end row-->
                                    <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                        <div class="col-12 text-center mt-3">
                                            <button class="btn btn-pkn " type="button" @click="carianCukai()">Carian Cukai
                                                Terperinci</button>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col-6 ">
                                            <button class="btn btn-pkn " type="button" @click="carianCukai()">Carian Cukai
                                                Terperinci</button>
                                        </div>
                                    </template>
                                </div>
                                <template v-if="cari.no_rujukan && butirans.length == 0">
                                    <center>
                                        <h5>Rekod Tidak dijumpai.</h5>
                                    </center>
                                </template>
                                <template v-if="butirans.length > 0">
                                    <div class="col-lg-9">
                                        <div class="row justify-content-center">

                                            <div class="card-body">
                                                <div class="col-lg-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <h4 class="card-title"><b class="text-primary">1.</b> Senarai
                                                                Hasil Carian</h4>
                                                        </div><!--end card-header-->
                                                        <div class="card-body">

                                                            <template
                                                                v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                                <template v-for="dt, index in butirans">
                                                                    <div class="card" v-if="dt.bakul == 0">
                                                                        <div class="card-header text-light bg-dark">
                                                                            <div class="fw-semibold m0">
                                                                                {{ dt.sumber_keterangan }}</div>
                                                                        </div>
                                                                        <div class="card-body">
                                                                            <div class="row">
                                                                                <div class="col-12">
                                                                                    <div class="fw-normal ">
                                                                                        {{ dt.no_rujukan }} |
                                                                                        {{ dt.keterangan }}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-xs-12">
                                                                                    <div class="fw-normal ">
                                                                                        <b>Perlu Bayar
                                                                                            :</b>{{
                                                                                                $zutil.currency(dt.amaun) }}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-xs-12">

                                                                                    <div class="fw-normal float-right">

                                                                                        <template
                                                                                            v-if="dt.detail.flag_halangan_id">
                                                                                            <span class="text-red">{{
                                                                                                dt.detail.halangan }}</span>

                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <template
                                                                                                v-if="dt.lkp_sumber_id != 9">
                                                                                                <div class="btn-pkn-1"
                                                                                                    @click="pilih(dt, 1)"
                                                                                                    v-if="dt.amaun > 0">
                                                                                                    <i
                                                                                                        class="dripicons-cart"></i>
                                                                                                </div>
                                                                                            </template>
                                                                                            <template v-else>
                                                                                                <template
                                                                                                    v-if="dt.detail.belum_bayar == 1">
                                                                                                    <div class="btn-pkn-1"
                                                                                                        @click="pilih(dt, 1)"
                                                                                                        v-if="dt.amaun > 0">
                                                                                                        <i
                                                                                                            class="dripicons-cart"></i>
                                                                                                    </div>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <b>Sudah Bayar</b>
                                                                                                </template>
                                                                                            </template>
                                                                                        </template>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>



                                                                    </div><br />
                                                                </template>
                                                                <div class="card bg-light p-2" v-if="total_carian">
                                                                    <w-flex>
                                                                        <div class="xs6">
                                                                            <div class="fw-semibold m0"> JUMLAH</div>

                                                                        </div>
                                                                        <div class="xs6 ">

                                                                            <div class="fw-normal float-right">
                                                                                <strong>{{ $zutil.currency(total_carian) }}
                                                                                </strong>
                                                                            </div>
                                                                        </div>
                                                                    </w-flex>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="table-responsive shopping-cart">

                                                                    <table class="table mb-0">
                                                                        <thead>
                                                                            <tr>

                                                                                <th class="border-top-0">Jenis Pembayaran
                                                                                </th>
                                                                                <th>No. Rujukan | Nama </th>
                                                                                <th class="border-top-0 text-right">Amaun
                                                                                    Perlu Bayar (RM)</th>
                                                                                <th></th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-for="dt, index in butirans">
                                                                                <template v-if="dt.bakul == 0">
                                                                                    <tr>
                                                                                        <td>
                                                                                            {{ dt.sumber_keterangan }}
                                                                                        </td>

                                                                                        <td>{{ dt.no_rujukan }} |
                                                                                            {{ dt.keterangan }}</td>
                                                                                        <td class="text-right">
                                                                                            {{ $zutil.currency(dt.amaun) }}
                                                                                        </td>
                                                                                        <td width="1%">
                                                                                            <template
                                                                                                v-if="dt.detail.flag_halangan_id">
                                                                                                {{ dt.detail.halangan }}

                                                                                            </template>
                                                                                            <template v-else>
                                                                                                <template
                                                                                                    v-if="dt.lkp_sumber_id != 9">
                                                                                                    <div class="btn-pkn-1"
                                                                                                        @click="pilih(dt, 1)"
                                                                                                        v-if="dt.amaun > 0">
                                                                                                        Tambah <i
                                                                                                            class="dripicons-cart"></i>
                                                                                                    </div>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <template
                                                                                                        v-if="dt.detail.belum_bayar == 1">
                                                                                                        <div class="btn-pkn-1"
                                                                                                            @click="pilih(dt, 1)"
                                                                                                            v-if="dt.amaun > 0">
                                                                                                            Tambah <i
                                                                                                                class="dripicons-cart"></i>
                                                                                                        </div>
                                                                                                    </template>
                                                                                                    <template v-else>
                                                                                                        <b>Sudah Bayar</b>
                                                                                                    </template>
                                                                                                </template>
                                                                                            </template>
                                                                                        </td>
                                                                                        <td width="1%">
                                                                                            <template
                                                                                                v-if="dt.lkp_sumber_id == 1">

                                                                                                <div class="btn-pkn-1">
                                                                                                    <a :href="dt.url"
                                                                                                        target="_blank"
                                                                                                        class="btn-pkn-3">
                                                                                                        Cetak <i
                                                                                                            class="dripicons-print ml1"></i>
                                                                                                    </a>
                                                                                                </div>

                                                                                            </template>
                                                                                        </td>
                                                                                    </tr>
                                                                                </template></template>
                                                                            <tr>

                                                                                <td>
                                                                                    <h6>Jumlah :</h6>
                                                                                </td>
                                                                                <td></td>
                                                                                <td class="text-dark text-right">
                                                                                    <strong>{{ $zutil.currency(total_carian)
                                                                                    }}
                                                                                    </strong>
                                                                                </td>
                                                                                <td></td>
                                                                            </tr>

                                                                        </tbody>
                                                                    </table>


                                                                </div>
                                                            </template>

                                                        </div><!--end card-body-->
                                                    </div>
                                                </div><!--end col-->

                                                <div class="col-lg-12 mt4">
                                                    <div class="card" v-if="bakul_ind">
                                                        <div class="card-header">
                                                            <h4 class="card-title"><b class="text-primary">2.</b> Senarai
                                                                Yang Ingin Dibayar</h4>
                                                        </div><!--end card-header-->
                                                        <div class="card-body">
                                                            <template
                                                                v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                                                <template v-for="dt, index in butirans">
                                                                    <div class="card border-0" v-if="dt.bakul == 1">

                                                                        <w-flex>
                                                                            <div class="xs6">
                                                                                <div class="fw-semibold m0">
                                                                                    {{ dt.sumber_keterangan }}</div>
                                                                                <div class="fw-normal ">
                                                                                    {{ dt.no_rujukan }} | {{ dt.keterangan
                                                                                    }}
                                                                                </div>
                                                                            </div>
                                                                            <div class="xs6 text-right">

                                                                                <div class="fw-normal ">
                                                                                    <b>Perlu Bayar :</b><br>
                                                                                    {{ $zutil.currency(dt.amaun) }}
                                                                                </div>
                                                                                <div class="fw-normal ">

                                                                                    <b> Bayar :</b> <br>
                                                                                    <template
                                                                                        v-if="dt.lkp_sumber_id == 1 || dt.lkp_sumber_id == 9 || dt.lkp_sumber_id == 11">
                                                                                        {{ $zutil.currency(dt.amaun_bayar)
                                                                                        }}
                                                                                    </template>
                                                                                    <template v-else>
                                                                                        <z-money
                                                                                            :validators="[validators.required]"
                                                                                            v-model:originalValue="dt.amaun_bayar"
                                                                                            v-on:keyup="checkAmaun(dt)"
                                                                                            v-on:change="pilih(dt, 1)" />
                                                                                        <span
                                                                                            class="tw-form-el__error error">{{
                                                                                                dt.mesej }}</span>
                                                                                    </template>
                                                                                </div>
                                                                                <div class="fw-normal float-right">
                                                                                    <div class="btn-pkn-2"
                                                                                        @click="pilih(dt, 0)">
                                                                                        <i class="dripicons-trash"></i>
                                                                                    </div>

                                                                                </div>

                                                                            </div>
                                                                        </w-flex>
                                                                    </div>
                                                                </template>
                                                                <div class="card bg-light" v-if="total_pilih">
                                                                    <w-flex>
                                                                        <div class="xs6">
                                                                            <div class="fw-semibold m0"> JUMLAH</div>

                                                                        </div>
                                                                        <div class="xs6 ">

                                                                            <div class="fw-normal float-right">
                                                                                <strong>{{ $zutil.currency(total_pilih) }}
                                                                                </strong>
                                                                            </div>
                                                                        </div>
                                                                    </w-flex>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="table-responsive shopping-cart">
                                                                    <table class="table mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th class="border-top-0" rowspan="2">Jenis
                                                                                    Pembayaran</th>
                                                                                <th rowspan="2">No. Rujukan | Nama</th>
                                                                                <th class="border-top-0 text-center"
                                                                                    colspan="2">Amaun (RM)</th>
                                                                                <th rowspan="2"></th>
                                                                                <th rowspan="2"></th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th class="border-top-0 text-center">Perlu
                                                                                    Bayar</th>
                                                                                <th class="border-top-0 text-center"> Bayar
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-for="dt, index in butirans">
                                                                                <template v-if="dt.bakul == 1">
                                                                                    <tr>
                                                                                        <td>
                                                                                            {{ dt.sumber_keterangan }}
                                                                                        </td>
                                                                                        <td>
                                                                                            {{ dt.no_rujukan }} |
                                                                                            {{ dt.keterangan }}</td>
                                                                                        <td class="text-right">
                                                                                            {{ $zutil.currency(dt.amaun) }}
                                                                                        </td>
                                                                                        <td class="text-right">
                                                                                            <template
                                                                                                v-if="dt.lkp_sumber_id == 1 || dt.lkp_sumber_id == 9 || dt.lkp_sumber_id == 11">
                                                                                                {{
                                                                                                    $zutil.currency(dt.amaun_bayar)
                                                                                                }}
                                                                                            </template>
                                                                                            <template v-else>
                                                                                                <z-money
                                                                                                    :validators="[validators.required]"
                                                                                                    v-model:originalValue="dt.amaun_bayar"
                                                                                                    v-on:keyup="checkAmaun(dt)"
                                                                                                    v-on:change="pilih(dt, 1)" />
                                                                                                <span
                                                                                                    class="tw-form-el__error error">{{
                                                                                                        dt.mesej }}</span>
                                                                                            </template>
                                                                                        </td>
                                                                                        <td width="1%">

                                                                                            <div class="btn-pkn-2"
                                                                                                @click="pilih(dt, 0)">
                                                                                                Padam <i
                                                                                                    class="dripicons-trash"></i>
                                                                                            </div>

                                                                                        </td>
                                                                                        <td width="1%">

                                                                                            <template
                                                                                                v-if="dt.lkp_sumber_id == 1">
                                                                                                <div class="btn-pkn-1">
                                                                                                    <a :href="dt.url"
                                                                                                        target="_blank"
                                                                                                        class="btn-pkn-3">
                                                                                                        Cetak <i
                                                                                                            class="dripicons-print ml1"></i>
                                                                                                    </a>
                                                                                                </div>
                                                                                            </template>

                                                                                        </td>
                                                                                    </tr>
                                                                                </template>

                                                                            </template>

                                                                            <tr>

                                                                                <td>
                                                                                    <h6>Jumlah :</h6>
                                                                                </td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td class="text-dark text-right">
                                                                                    <strong>{{ $zutil.currency(total_pilih)
                                                                                    }}
                                                                                    </strong>
                                                                                </td>
                                                                                <td></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>



                                                                </div>
                                                            </template>
                                                        </div><!--end card-body-->


                                                        <div class="mb-4">
                                                            <div class="px-3">
                                                                <div class="mb2"><b>CARA PEMBAYARAN : </b></div>
                                                                <b>1.</b> Sila tekan butang <b>tambah</b> bagi bil yang
                                                                ingin dibayar<br>
                                                                <b>2.</b> Buat carian baharu di <b>Kotak Carian</b>
                                                                sekiranya ingin menambah bil<br>
                                                                <b>3.</b> Semak Senarai dan jumlah bayaran yang ingin
                                                                dilakukan di Senarai <b>Jenis Pembayaran Ingin
                                                                    Dibayar</b><br>
                                                                <b>4.</b> Sila Pilih <b>Kaedah Pembayaran</b><br>
                                                                <b>5.</b> Baca dan klik pada <b>setuju terma dan syarat</b>,
                                                                sekiranya bersetuju<br>
                                                                <b>6.</b> Klik Pada butang <b>Bayar</b> bagi membuat
                                                                pembayaran<br>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div><!--end col-->

                                                <div class="col-lg-12" v-if="auth.user.id == 0">

                                                    <w-form class="" v-model="form.valid"
                                                        v-model:errors-count="form.errorsCount" @validate="onValidate"
                                                        @success="simpanProfil()">
                                                        <div class="card" v-if="total_pilih">
                                                            <div class="card-header">
                                                                <h4 class="card-title"><b class="text-primary">3.</b> Profil
                                                                    Pembayar</h4>
                                                                <!-- <p class="text-muted mb-0">Sila Pastikan maklumat dibawah adalah benar dan tepat.</p> -->
                                                            </div><!--end card-header-->
                                                            <div class="card-body">
                                                                <template v-if="$zutil.pwaMobile() == 0">
                                                                    <w-flex class="mt2">
                                                                    <div class="xs6 mr5">
                                                                        <w-input v-model="form.nama" required label="Nama *"
                                                                            :validators="[validators.required]" />
                                                                    </div>
                                                                    <div class="xs6">
                                                                        <w-input v-model="form.no_id" required
                                                                            label="No. KP / Pasport / Syarikat *"
                                                                            :validators="[validators.required]" />
                                                                    </div>
                                                                    </w-flex>
                                                                    <w-flex class="mt2">
                                                                        <div class="xs6 mr5">
                                                                            <w-input v-model="form.emel" required label="Emel *"
                                                                                :validators="[validators.required, validators.email]" />
                                                                        </div>
                                                                        <div class="xs6">
                                                                            <w-input v-model="form.no_tel" required
                                                                                label="No Tel *"
                                                                                :validators="[validators.required]" />
                                                                        </div>
                                                                    </w-flex>
                                                                </template>
                                                                <template v-if="$zutil.pwaMobile() == 2">
                                                                    <div class="xs12">
                                                                        <w-input v-model="form.nama" required label="Nama *"
                                                                            :validators="[validators.required]" />
                                                                    </div>
                                                                    <div class="xs12">
                                                                        <w-input v-model="form.no_id" required
                                                                            label="No. KP / Pasport / Syarikat *"
                                                                            :validators="[validators.required]" />
                                                                    </div>
                                                                    <div class="xs12">
                                                                        <w-input v-model="form.emel" required label="Emel *"
                                                                            :validators="[validators.required, validators.email]" />
                                                                    </div>
                                                                    <div class="xs12">
                                                                        <w-input v-model="form.no_tel" required
                                                                            label="No Tel *"
                                                                            :validators="[validators.required]" />
                                                                    </div>
                                                                </template>


                                                                
                                                                <w-flex class="mt2">
                                                                    <div class="xs12 mr5">
                                                                        <w-textarea v-model="form.alamat1"
                                                                            :validators="[validators.required]">Alamat
                                                                            *</w-textarea>
                                                                    </div>
                                                                </w-flex>

                                                                <!-- <w-button class="my1" @click="caraBayar()" > Teruskan</w-button> -->
                                                                <w-button class="my1" type="submit"
                                                                    :disabled="form.valid === false"
                                                                    :loading="form.submitted && !form.sent">
                                                                    Teruskan</w-button>


                                                            </div><!--end card-body-->
                                                        </div>
                                                    </w-form>
                                                </div><!--end col-->


                                                <!-- -->




                                            </div> <!--end col-->

                                            <!-- -->

                                        </div><!--end row-->

                                    </div><!--end col-->
                                    <div class="col-lg-3">
                                        <div class="card mb4">
                                            <div class="card-header">
                                                <div class="row align-items-center">
                                                    <div class="col">
                                                        <h4 class="card-title"><i class="mdi mdi-cart-outline me-2"></i>
                                                            Senarai Jenis Pembayaran Ingin Dibayar</h4>
                                                    </div><!--end col-->
                                                </div> <!--end row-->
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                                <div class="text-center">
                                                    <div id="ana_device" class="apex-charts hide"></div>

                                                </div>
                                                <div class="table-responsive mt-2" v-if="total_pilih">
                                                    <table class="table border-dashed mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Jenis Pembayaran</th>
                                                                <th class="text-end">Jumlah (RM)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-if="total_cukai_pilih">
                                                                <td>{{ sumber[0].keterangan }}</td>
                                                                <td class="text-end"> {{ $zutil.currency(total_cukai_pilih)
                                                                }}
                                                                </td>
                                                            </tr>
                                                            <tr v-if="total_perumahan_pilih">
                                                                <td>{{ sumber[1].keterangan }}</td>
                                                                <td class="text-end">
                                                                    {{ $zutil.currency(total_perumahan_pilih) }}</td>
                                                            </tr>

                                                            <tr v-if="total_pendidikan_pilih">
                                                                <td>{{ sumber[2].keterangan }}</td>
                                                                <td class="text-end">
                                                                    {{ $zutil.currency(total_pendidikan_pilih) }}</td>
                                                            </tr>

                                                            <tr v-if="total_upuk_pilih">
                                                                <td>{{ sumber[3].keterangan }}</td>
                                                                <td class="text-end"> {{ $zutil.currency(total_upuk_pilih)
                                                                }}
                                                                </td>
                                                            </tr>

                                                            <tr v-if="total_bil_pilih">
                                                                <td>{{ sumber[8].keterangan }}</td>
                                                                <td class="text-end"> {{ $zutil.currency(total_bil_pilih) }}
                                                                </td>
                                                            </tr>
                                                            <tr v-if="total_lelong_pilih">
                                                                <td>{{ sumber[10].keterangan }}</td>
                                                                <td class="text-end">
                                                                    {{ $zutil.currency(total_lelong_pilih) }}</td>
                                                            </tr>
                                                        </tbody>
                                                        <thead>
                                                            <tr>
                                                                <th>JUMLAH</th>
                                                                <th class="text-end"> {{ $zutil.currency(total_pilih) }}
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                    </table><!--end /table-->
                                                </div><!--end /div-->
                                            </div><!--end card-body-->
                                        </div><!--end card-->


                                        <div class="card mb4" v-if="total_pilih && cara_bayar">
                                            <div class="card-header">
                                                <h4 class="card-title"> <b class="text-primary">
                                                        <template v-if="auth.user.id == 0">4.</template>
                                                        <template v-else>3.</template>
                                                    </b> Cara Pembayaran</h4>
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                                <div class="d-flex">
                                                    <div class="d-block ms-2 align-self-center">


                                                    </div>
                                                </div>
                                                <div class="accordion accordion-flush checkout-accordion"
                                                    id="accordionFlushExample">

                                                    <!-- <div class="accordion-item" v-if="total_pilih <= 30000 && total_pilih >= 1"> -->
                                                        
                                                    <!-- <div class="accordion-item" v-if="total_pilih >= 1">
                                                        <h2 class="accordion-header mt-0" id="flush-headingTwo">
                                                            <button class="accordion-button collapsed d-flex " type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                                                aria-controls="flush-collapseTwo"
                                                                @click="pilihCaraTerima(1)">
                                                                <img src="assets/images/cards/card-10.svg" alt=""
                                                                    height="30">
                                                                <span class="align-self-center ms-2 fw-semibold">FPX</span>
                                                                &nbsp;&nbsp;&nbsp;<h2><i class="dripicons-checkmark"
                                                                        v-if="form.lkp_cara_terima_id == 1"></i></h2>
                                                            </button>

                                                        </h2>

                                                    </div> -->
                                                    <div class="accordion-item">
                                                        <h2 class="accordion-header mt-0" id="flush-headingOne">
                                                            <button class="accordion-button collapsed d-flex " type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                                                aria-controls="flush-collapseTwo"
                                                                @click="pilihCaraTerima(2)">
                                                                <img src="assets/images/cards/card-2.png" alt=""
                                                                    height="30">
                                                                <span class="align-self-center ms-2 fw-semibold">Kad
                                                                    Kredit</span> &nbsp;&nbsp;&nbsp;<h2><i
                                                                        class="dripicons-checkmark"
                                                                        v-if="form.lkp_cara_terima_id == 2"></i></h2>
                                                            </button>
                                                        </h2>

                                                    </div>

                                                </div>

                                                <div class="mb4 mt2"><b>Pengumuman :</b></div>

                                                <div class="mb4">
                                                    Cara pembayaran melalui eWallet akan dapat dilakukan di iBayaq dalam
                                                    masa terdekat.
                                                </div>

                                                 <!-- <div class="mb2">
                                                    Mohon Maaf, Cara Pembayaran melalui FPX tergendala buat masa kini. Harap maklum.
                                                </div> -->



                                                Sekian, Terima Kasih

                                            </div><!--end card-body-->

                                        </div>
                                        <!-- <div class="card mb4" v-if="total_pilih &&  cara_bayar">
                                        <div class="card-body">
                                       <div class="mb3"><b>Had limit kadar bayaran FPX :</b></div>
                                           <div class="card-scroll">
                                               <div class="px-3 py-3">
                                                   <table border="0" cellpadding="1" cellspacing="1" style="width:100%">
                                                      <tbody>
                                                         <tr>
                                                            <td width="32%">Maksimum</td>
                                                            <td style="text-align: center;" width="32%">B2B</td>
                                                            <td style="text-align: right;" width="36%">RM 1,000,000</td>
                                                         </tr>
                                                         <tr>
                                                            <td>Minimum</td>
                                                            <td style="text-align: center;">B2B</td>
                                                            <td style="text-align: right;">RM 2.00</td>
                                                         </tr>
                                                         <tr>
                                                            <td>Maksimum</td>
                                                            <td style="text-align: center;">B2C</td>
                                                            <td style="text-align: right;">RM 30,000</td>
                                                         </tr>
                                                         <tr>
                                                            <td>Minimum</td>
                                                            <td style="text-align: center;">B2C</td>
                                                            <td style="text-align: right;">RM 1.00</td>
                                                         </tr>
                                                      </tbody>
                                                   </table>
                                               </div>
                                           </div>
                                   </div>       
                                    </div>     -->
                                        <div class="card" v-if="total_pilih && cara_bayar">


                                            <div class="card-header">
                                                <h4 class="card-title"> <b class="text-primary">4.</b> Terma & Syarat</h4>
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                                Disini saya mengesahkan bahawa saya memperakui segala terma dan syarat yang
                                                telah ditetapkan oleh pihak kerajaan kedah melalui platform iBayaq
                                                <br>
                                                <w-checkbox class="mt3 mb3" v-model="form.agree">Setuju terima dan
                                                    syarat</w-checkbox> <br>
                                                <!-- {{form.agree}} |{{form.lkp_cara_terima_id}}|{{form.check_amaun}}|{{data_profil.no_id}} -->
                                                <template
                                                    v-if="form.agree == true && form.lkp_cara_terima_id != 0 && form.check_amaun != 0 && data_profil.no_id">
                                                    <!-- <form action="http://pg.lokal.my/pay/proceed" method="post"> -->
                                                    <form :action="url_payment" method="post">
                                                        <input type="hidden" name="flow" value="01">
                                                        <input type="hidden" name="api" value="1">
                                                        <input type="hidden" name="token" value="1234">
                                                        <input type="hidden" name="method"
                                                            v-model="form.lkp_cara_terima_id">
                                                        <input type="hidden" name="id" v-model="troli.id">
                                                        <input type="hidden" name="return_url" v-model="url_return">
                                                        <input type="hidden" name="callback_url" v-model="url_callback">
                                                        <input type="hidden" name="amount" v-model="total_pilih">
                                                        <input type="hidden" name="profil_id" v-model="data_profil.id">
                                                        <input type="hidden" name="name" v-model="data_profil.nama">
                                                        <input type="hidden" name="email" v-model="data_profil.emel">
                                                        <input type="hidden" name="mobile" v-model="data_profil.no_tel">
                                                        <input type="hidden" name="description" value="Bayaran iBayaq">
                                                        <template v-for="dt, index in butirans">
                                                            <template v-if="dt.bakul == 1">

                                                                <input type="hidden" name="troli_detail_id[]"
                                                                    v-model="dt.id">
                                                                <input type="hidden" name="troli_detail_amaun_bayar[]"
                                                                    v-model="dt.amaun_bayar">
                                                            </template>
                                                        </template>
                                                        <!-- <button type="submit">Bayar</button> -->
                                                        <w-button class="my1" type="submit"
                                                            :disabled="form.valid === false">Bayar </w-button>
                                                    </form>
                                                </template>
                                                <template v-else>
                                                    <w-button class="my1" :disabled="true"> Bayar</w-button>
                                                </template>

                                            </div><!--end card-body-->

                                        </div>



                                    </div> <!--end col-->

                                </template>
                            </div><!--end row-->
                            <!-- -->

                        </div><!--end card-body-->
                    </div>
                </template>



            </div>


        </div><br><br><br><br><br><br>
        <w-dialog v-if="$zutil.pwaMobile() != 1" v-model="dialog_carian.show" :fullscreen="dialog_carian.fullscreen"
            :width="dialog_carian.width" :persistent="dialog_carian.persistent"
            :persistent-no-animation="dialog_carian.persistentNoAnimation" title-class="primary-light1--bg white">
            <template #title>
                Carian Cukai TERPERINCI
            </template>
            <div class="page-wrapper-portal">

                <div class="pkn-contact">
                    <w-form class="form-horizontal auth-form my-1" v-model="form_carian.valid">
                        <div class="form-group mb-3">
                            <div class="input-group">

                                
                                    <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                        <w-flex class="mt2">
                                        <div class="col-12">
                                            <w-select :items="daerah" class="mb-2" v-model="form_carian.lkp_daerah_id"
                                                label="Daerah" :validators="[validators.required]" />
                                            <w-select :items="mukimDaerah" class="mb-2" v-model="form_carian.lkp_mukim_id"
                                                label="Mukim" :validators="[validators.required]" />
                                            <w-select :items="hmJenis" class="mb-2" v-model="form_carian.lkp_hm_jenis_id"
                                                label="Jenis Hak Milik" :validators="[validators.required]" />
                                            <w-input label="No. Hak Milik" class="mb-2" v-model="form_carian.no_hm"
                                                name="no_hm" :validators="[validators.min8]" />
                                            <w-input label="Bangunan" class="mb-2" v-model="form_carian.no_bangunan"
                                                name="no_hm"  />
                                            <template v-if="form_carian.no_bangunan">
                                                <w-input label="Tingkat" class="mb-2" v-model="form_carian.no_tingkat"
                                                    name="no_hm" :validators="[validators.min3]" />
                                                <w-input label="Petak" class="mb-2" v-model="form_carian.no_petak"
                                                    name="no_hm" :validators="[validators.min5]" />
                                            </template>
                                            <template v-else>
                                                <w-input label="Tingkat" class="mb-2" v-model="form_carian.no_tingkat"
                                                    name="no_hm"  />
                                                <w-input label="Petak" class="mb-2" v-model="form_carian.no_petak"
                                                    name="no_hm"  />
                                            </template>
                                        </div>
                                    </w-flex>
                                    </template>
                                    <template v-else>
                                        <w-flex class="mt2">
                                            <div class="col-md-3">
                                                <w-select :items="daerah" v-model="form_carian.lkp_daerah_id" label="Daerah"
                                                    :validators="[validators.required]" />
                                            </div>

                                            <div class="col-md-3">
                                                <w-select :items="mukimDaerah" v-model="form_carian.lkp_mukim_id" label="Mukim"
                                                    :validators="[validators.required]" />
                                            </div>
                                            <div class="col-md-3">
                                                <w-select :items="hmJenis" v-model="form_carian.lkp_hm_jenis_id"
                                                    label="Jenis Hak Milik" :validators="[validators.required]" />

                                            </div>
                                            <div class="col-md-3">
                                                <w-input label="No. Hak Milik" v-model="form_carian.no_hm" name="no_hm"
                                                    :validators="[validators.min8]" />
                                            </div>
                                        </w-flex>
                                        <w-flex class="mt2">
                                            <div class="col-md-3">
                                                <w-input label="Bangunan" v-model="form_carian.no_bangunan" name="no_bangunan"
                                                     />
                                            </div>
                                            <template v-if="form_carian.no_bangunan">
                                                <div class="col-md-3">
                                                    <w-input label="Tingkat" v-model="form_carian.no_tingkat" name="no_tingkat"
                                                        :validators="[validators.min3]" />
                                                </div>
                                                <div class="col-md-3">
                                                    <w-input label="Petak" v-model="form_carian.no_petak" name="no_petak"
                                                        :validators="[validators.min5]" />
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="col-md-3">
                                                    <w-input label="Tingkat" v-model="form_carian.no_tingkat" name="no_tingkat" />
                                                </div>
                                                <div class="col-md-3">
                                                    <w-input label="Petak" v-model="form_carian.no_petak" name="no_petak" />
                                                </div>
                                            </template>
                                        </w-flex>
                                        
                                    </template>

                                
                            </div>
                        </div>

                    </w-form>


                </div>
            </div>
            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialog_carian.show = false">Tutup</w-button>
                <template
                    v-if="form_carian.lkp_daerah_id && form_carian.lkp_mukim_id && form_carian.lkp_hm_jenis_id && form_carian.no_hm">
                    <w-button type="submit" class="ml1" :disabled="form_carian.valid === false" @click="carianPerinci()">
                        Cari
                    </w-button>
                </template>
                <template v-else>
                    <w-button type="submit" class="ml1">
                        Cari
                    </w-button>
                </template>

            </template>

        </w-dialog>

        <w-dialog v-if="$zutil.pwaMobile() == 1" v-model="dialog_carian.show" :fullscreen="dialog_carian.fullscreen"
            :persistent="dialog_carian.persistent" :persistent-no-animation="dialog_carian.persistentNoAnimation">
            <template #title>
                Carian Cukai TERPERINCI
            </template>
            <div class="page-wrapper-portal">

                <div class="pkn-contact">
                    <w-form class="form-horizontal auth-form my-1" v-model="form_carian.valid">
                        <div class="form-group mb-3">
                            <div class="input-group">

                                <w-flex class="mt2">
                                    <template v-if="$zutil.pwaMobile() == 1 || $zutil.pwaMobile() == 2">
                                        <div class="col-12">
                                            <w-select :items="daerah" class="mb-2" v-model="form_carian.lkp_daerah_id"
                                                label="Daerah" :validators="[validators.required]" />
                                            <w-select :items="mukimDaerah" class="mb-2" v-model="form_carian.lkp_mukim_id"
                                                label="Mukim" :validators="[validators.required]" />
                                            <w-select :items="hmJenis" class="mb-2" v-model="form_carian.lkp_hm_jenis_id"
                                                label="Jenis Hak Milik" :validators="[validators.required]" />
                                            <w-input label="No. Hak Milik" class="mb-2" v-model="form_carian.no_hm"
                                                name="no_hm" :validators="[validators.min8]" />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col-md-3">
                                            <w-select :items="daerah" v-model="form_carian.lkp_daerah_id" label="Daerah"
                                                :validators="[validators.required]" />
                                        </div>

                                        <div class="col-md-3">
                                            <w-select :items="mukimDaerah" v-model="form_carian.lkp_mukim_id" label="Mukim"
                                                :validators="[validators.required]" />
                                        </div>
                                        <div class="col-md-3">
                                            <w-select :items="hmJenis" v-model="form_carian.lkp_hm_jenis_id"
                                                label="Jenis Hak Milik" :validators="[validators.required]" />

                                        </div>
                                        <div class="col-md-3">
                                            <w-input label="No. Hak Milik" v-model="form_carian.no_hm" name="no_hm"
                                                :validators="[validators.min8]" />
                                        </div>
                                    </template>

                                </w-flex>
                            </div>
                        </div>

                    </w-form>


                </div>
            </div>
            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialog_carian.show = false">Tutup</w-button>
                <template
                    v-if="form_carian.lkp_daerah_id && form_carian.lkp_mukim_id && form_carian.lkp_hm_jenis_id && form_carian.no_hm">
                    <w-button type="submit" class="ml1" :disabled="form_carian.valid === false" @click="carianPerinci()">
                        Cari
                    </w-button>
                </template>
                <template v-else>
                    <w-button type="submit" class="ml1">
                        Cari
                    </w-button>
                </template>

            </template>

        </w-dialog>




        <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width"
            :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white">
            <template #title>
                <!-- <w-icon class="mr2">fal fa-pencil</w-icon> -->
                {{ dialog.data.sumber_keterangan }}
            </template>
            <div class="page-wrapper-portal">
                <div class="row">

                    <template v-if="dialog.data.lkp_sumber_id == 1">
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama :</div>
                                <div class="fw-normal ">
                                    <template v-for="dt, index in dialog.data.detail.pemiliks">
                                        <template v-if="index == 0">{{ dt.profil_nama }}</template>
                                    </template>
                                </div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Pejabat Tanah :</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.jabatan_keterangan }}
                                </div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Alamat :</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.alamat }}

                                </div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Daerah :</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.daerah_keterangan }}

                                </div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0"> Mukim/Bandar/Pekan</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.mukim_keterangan }}
                                </div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Tarikh Daftar :</div>
                                <div class="fw-normal ">
                                    <template v-for="dt, index in dialog.data.detail.cukais">
                                        <template v-if="index == 0 && dt.tarikh_daftar">{{
                                            $zutil.dateformat(dt.tarikh_daftar) }}</template>
                                        <template v-else>-</template>
                                    </template>

                                </div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0"> Jenis Hakmilik</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.hm_jenis_keterangan }}
                                </div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">No. Lot :</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.no_lot }}
                                </div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0"> No. KP</div>
                                <div class="fw-normal ">
                                    <template v-for="dt, index in dialog.data.detail.pemiliks">
                                        <template v-if="index == 0">{{ dt.profil_no }} </template>
                                    </template>
                                </div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Keluasan :</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.keluasan }} {{ dialog.data.detail.unit_keterangan }}
                                </div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0"> No. Hakmilik</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.no_hm }}
                                </div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Kegunaan :</div>
                                <div class="fw-normal ">
                                    {{ dialog.data.detail.hm_kegunaan_keterangan }}
                                </div>
                            </div>
                        </w-flex>

                        <div class="table-responsive shopping-cart mt3">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th rowspan="2">Perkara </th>
                                        <th colspan="6" lass="border-top-0 text-center">
                                            <center>Amaun (RM)</center>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="border-top-0 text-right">Cukai</th>
                                        <th class="border-top-0 text-right">Telah Bayar</th>
                                        <th class="border-top-0 text-right">Pelarasan</th>
                                        <th class="border-top-0 text-right">Ampun Hasil</th>
                                        <th class="border-top-0 text-right">Diskaun</th>
                                        <th class="border-top-0 text-right">Baki</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="dt, index in dialog.data.detail.cukais">
                                        <tr>
                                            <td>
                                                {{ dt.keterangan }}
                                            </td>
                                            <td class="text-right">{{ $zutil.currency(dt.rm_debit) }}</td>
                                            <td class="text-right">{{ $zutil.currency(dt.rm_resit) }}</td>
                                            <td class="text-right">{{ $zutil.currency(dt.rm_kredit) }}</td>
                                            <td class="text-right">{{ $zutil.currency(dt.rm_ampun_hasil) }}</td>
                                            <td class="text-right">{{ $zutil.currency(dt.rm_diskaun) }}</td>
                                            <td class="text-right">{{ $zutil.currency(dt.amaun_debit) }}</td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <th colspan="6">Jumlah</th>
                                        <td class="text-dark text-right"><strong>{{ $zutil.currency(dialog.data.amaun) }}
                                            </strong></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </template>
                    <template v-if="dialog.data.lkp_sumber_id == 2">
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Kod Permis :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.KOD_PREMIS }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama Pemilik :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA_PEMILIK }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">No Kad Pengenalan (Lama) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.KPLAMA_PEMILIK }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">No Kad Pengenalan (Baru) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.KPBARU_PEMILIK }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama Skim :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA_SKIM }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Alamat Skim :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.ALAMAT1_RUMAH }}
                                    {{ dialog.data.detail.ALAMAT2_RUMAH }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Ansuran Bulanan (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.KADAR_ANS_SEWA }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Baki Harga Rumah (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.BAKIRUMAH }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Jumlah Tunggakan (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.TUNGGAKAN_ASAL }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0"></div>
                                <div class="fw-normal "></div>
                            </div>
                        </w-flex>

                    </template>
                    <template v-if="dialog.data.lkp_sumber_id == 3">
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">No. LBNK :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NO_LBNK }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA_PENUH }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">No Kad Pengenalan :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.IC_BARU }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Alamat</div>
                                <div class="fw-normal ">{{ dialog.data.detail.ALAMAT_SURAT }}</div>
                            </div>
                        </w-flex>

                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Ansuran Bulanan (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.ANSURAN_BULANAN }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Jumlah Baki (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.JUMLAH_BAKI }}</div>
                            </div>
                        </w-flex>


                    </template>

                    <template v-if="dialog.data.lkp_sumber_id == 4">
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">No Kad Pengenalan :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NOKP_PEMINJAM }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama Peminjam :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA_PEMINJAM }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama Syarikat :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA_SYARIKAT }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama Skim :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA_SKIM }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Ansuran Bulanan (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.ANS_BULANAN }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">Jumlah Pinjaman (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.JUMLAH_PINJAMAN }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Jumlah Perlu Bayar (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.JUMLAH_PERLU_BAYAR }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0"></div>
                                <div class="fw-normal "></div>
                            </div>
                        </w-flex>

                    </template>


                    <template v-if="dialog.data.lkp_sumber_id == 5">
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Id Pendaftaran :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.IDPENDAFTARAN }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">No KP :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NO_KP }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">KOD :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.KOD }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">NO TELEFON :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.HP_NO }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">EMEL :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.EMAIL }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Jumlah Perlu Bayar (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.JUMLAH_PERLU_BAYAR }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0"></div>
                                <div class="fw-normal "></div>
                            </div>
                        </w-flex>

                    </template>
                    <template v-if="dialog.data.lkp_sumber_id == 6">
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Id Pendaftaran :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.ID }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">No KP :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.IC }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Nama :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.NAMA_PENUH }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">JENIS :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.JENIS }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">NO TELEFON :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.TEL_BIMBIT }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0">EMEL :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.EMAIL }}</div>
                            </div>
                        </w-flex>
                        <w-flex justify-center align-center class="mb3">
                            <div class="xs6">
                                <div class="fw-semibold m0">Jumlah Perlu Bayar (RM) :</div>
                                <div class="fw-normal ">{{ dialog.data.detail.AMAUN_PERLU_BAYAR }}</div>
                            </div>
                            <div class="xs6">
                                <div class="fw-semibold m0"></div>
                                <div class="fw-normal "></div>
                            </div>
                        </w-flex>

                    </template>
                </div>
            </div>

            <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
            </template>
        </w-dialog>
    </layout>
</template>

<script type="text/javascript">
import Menu from '../Menu.vue'
import MenuNav from '../MenuNav.vue'

import ZResource from '@/Modules/z-resource'

export default {
    extends: ZResource,
    components: {
        Menu, MenuNav
    },
    setup() {
    },
    props: {
        auth: [Array, Object],
        password: [Array, Object],
        butirans: [Array, Object],
        sumber: [Array, Object],

        profil: Object,
        troli: Object,
        url_callback: String,
        url_return: String,
        url_payment: String,
    },
    data() {
        return {
            currentStep: 1,
            totalSteps: 3,
            progress: 0,
            no_rujukan: '',
            bakul_ind: 0,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: ' ',
                precision: 2,
                masked: false
            },
            daerah: [],
            mukim: [],
            hmJenis: [],
            description_pay: "",
            errors: null,
            data_profil: {},
            cara_bayar: 0,
            senarai: [],
            total_carian: 0,
            total_pilih: 0,
            total_cukai_pilih: 0,
            total_perumahan_pilih: 0,
            total_pendidikan_pilih: 0,
            total_upuk_pilih: 0,
            total_bil_pilih: 0,
            total_lelong_pilih: 0,
            cari: 0,
            loading: 0,
            password: '',
            passwordMatch: null,
            currentPassword: '',
            form: {
                lkp_cara_terima_id: 0,
                check_amaun: 1
            },
            form_carian: {
                valid: false,
                lkp_mukim_id: '',
                lkp_daerah_id: '',
                lkp_hm_jenis_id: '',
                no_hm: '',
                no_bangunan: '',
                no_tingkat: '',
                no_petak: '',
                no_akaun: '',
                no_lot: ''
            },
            dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                data: {}
            },
            dialog_carian: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
                data: {}
            },
            dialog_authenticate: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 300,
                data: {}
            },
        }
    },


    computed: {
        mukimDaerah: function () {
            let result = [];
            if (this.mukim)
                result = this.mukim.filter(
                    (i) => i.lkp_daerah_id == this.form_carian.lkp_daerah_id
                );
            return result;
        },
    },
    methods: {
        nextStep() {
            if (this.currentStep < this.totalSteps) {
                this.currentStep++;
                this.
                this.progress = (this.currentStep / this.totalSteps) * 100;
            }
        },
        prevStep() {
            if (this.currentStep > 1) {
                this.currentStep--;
                this.progress = (this.currentStep / this.totalSteps) * 100;
            }
        },
        carian(c) {
            // this.cari.no_rujukan = this.no_rujukan
            this.loading = 1;
            this.dialog_carian.show = 0
            if (c == 1) {

                this.$inertia.visit(window.route('landing.carian') + '?c=1&no_hm=' + this.form_carian.no_hm + '&no_akaun=' + this.form_carian.no_akaun + '&no_lot=' + this.form_carian.no_lot + '&lkp_mukim_id=' + this.form_carian.lkp_mukim_id + '&lkp_daerah_id=' + this.form_carian.lkp_daerah_id + '&lkp_hm_jenis_id=' + this.form_carian.lkp_hm_jenis_id, { preserveState: true, onSuccess: () => { return Promise.all([this.total(),]) } })
            } else {
                this.$inertia.visit(window.route('landing.carian') + '?c=0&no_rujukan=' + this.no_rujukan, { preserveState: true, onSuccess: () => { return Promise.all([this.total(),]) } })
            }
        },

        carianPerinci() {
            var kedah = '02'
            var daerah = ''
            var mukim = ''
            var jenis = ''
            for (var i in this.daerah) {
                if (this.daerah[i].value == this.form_carian.lkp_daerah_id) {
                    daerah = this.daerah[i].kod
                }
            }
            for (var i in this.mukim) {
                if (this.mukim[i].value == this.form_carian.lkp_mukim_id) {
                    mukim = this.mukim[i].kod
                }
            }
            for (var i in this.hmJenis) {
                if (this.hmJenis[i].value == this.form_carian.lkp_hm_jenis_id) {
                    jenis = this.hmJenis[i].kod
                }
            }
            this.no_rujukan = kedah + daerah + mukim + jenis + this.form_carian.no_hm + this.form_carian.no_bangunan + this.form_carian.no_tingkat + this.form_carian.no_petak;
            this.no_rujukan = this.no_rujukan.replace(/undefined/g, "");
            this.carian(0)

        },

        paparan(dt) {
            this.dialog.show = 1
            this.dialog.data = dt
        },
        authenticate() {
            this.dialog_authenticate.show = 1;
        },
        checkPassword() {
            // Make an API request to the server for password verification
            axios.post('/check-password', { password: this.password })
                .then(response => {
                    this.passwordMatch = response.data.passwordMatch;
                    console.log(this.passwordMatch);

                })
                .catch(() => {
                    this.passwordMatch = false;
                });
        },

        carianCukai() {
            this.form_carian = {
                lkp_mukim_id: '',
                lkp_daerah_id: '',
                lkp_hm_jenis_id: '',
                no_hm: '',
                no_akaun: '',
                no_lot: '',
                valid: false
            }
            this.dialog_carian.show = 1
        },
        daerahMukim(lkp_daerah_id) {
            alert(lkp_daerah_id)
        },


        send() {
            // alert('oke');
            var form = document.getElementById("send");
            form.action = 'http://pg.lokal.my/pay/proceed';
            return true;
        },

        total() {
            console.log('checking');
            this.loading = 0;
            this.total_carian = 0
            this.total_pilih = 0
            this.total_cukai_pilih = 0
            this.total_perumahan_pilih = 0
            this.total_pendidikan_pilih = 0
            this.total_upuk_pilih = 0
            this.total_bil_pilih = 0
            this.total_lelong_pilih = 0
            // this.form.check_amaun = 1
            this.errors = null
            this.description_pay = ""
            for (var i in this.butirans) {
                if (this.butirans[i].bakul == 1) {
                    this.form.check_amaun = 1
                    this.bakul_ind = 1
                    this.total_pilih = this.total_pilih + this.butirans[i].amaun_bayar
                    if (this.butirans[i].lkp_sumber_id == 1) {
                        this.total_cukai_pilih = this.total_cukai_pilih + this.butirans[i].amaun_bayar
                    }
                    if (this.butirans[i].lkp_sumber_id == 2) {
                        this.total_perumahan_pilih = this.total_perumahan_pilih + this.butirans[i].amaun_bayar
                    }

                    if (this.butirans[i].lkp_sumber_id == 3) {
                        this.total_pendidikan_pilih = this.total_pendidikan_pilih + this.butirans[i].amaun_bayar
                    }
                    if (this.butirans[i].lkp_sumber_id == 4) {
                        this.total_upuk_pilih = this.total_upuk_pilih + this.butirans[i].amaun_bayar
                    }
                    if (this.butirans[i].lkp_sumber_id == 9) {
                        this.total_bil_pilih = this.total_bil_pilih + this.butirans[i].amaun_bayar
                    }
                    if (this.butirans[i].lkp_sumber_id == 11) {
                        this.total_lelong_pilih = this.total_lelong_pilih + this.butirans[i].amaun_bayar
                    }
                    this.description_pay = this.description_pay + ' ' + this.butirans[i].sumber_keterangan + ' ' + this.butirans[i].no_rujukan + ''
                } else {
                    this.total_carian = this.total_carian + this.butirans[i].amaun_bayar
                }
                if (this.butirans[i].amaun_bayar < this.butirans[i].amaun_min) {
                    this.form.check_amaun = 0

                }
            }
            this.no_rujukan = ''

            if (this.auth.user.id > 0) {
                this.caraBayar();
            }
        },

        caraBayar() {
            this.cara_bayar = 1;
        },

        bayar() {

            this.$zcomm.add('butiran.bayar', this.form)
                .then(res => {

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                    }
                    this.$zutil.notify("Data Berjaya Dihantar.")
                    // if(this.auth.user.id != 0){
                    this.$inertia.visit(this.$route('landing.transaksi') + '?resit_id=' + res)
                    Swal.fire({
                        title: 'Berjaya',
                        text: 'Data Berjaya Dihantar',
                        icon: 'success',
                        timer: 60000,
                        showConfirmButton: false,
                        showCloseButton: true,
                    })
                    // }else{
                    //   this.$inertia.visit(this.$route('landing'))
                    // }

                })
                .finally(() => {

                });


        },
        simpanProfil() {

            this.$zcomm.add('profil.simpan', this.form)
                .then(res => {

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                    }
                    this.$zutil.notify("Data Berjaya Simpan.")
                    this.data_profil = res
                    this.caraBayar()
                    // if(this.auth.user.id != 0){
                    // this.$inertia.visit(this.$route('landing.transaksi')+'?resit_id='+res)
                    // }else{
                    //   this.$inertia.visit(this.$route('landing'))
                    // }

                })
                .finally(() => {

                });

        },

        checkAmaun(dt) {

            this.form.check_amaun = 0
            if (dt.amaun_bayar < dt.amaun_min) {
                dt.mesej = 'Amaun Minimun ' + this.$zutil.currency(dt.amaun_min)
            } else {
                dt.mesej = null
            }
            this.total()
            this.pilih(dt, 1)
        },

        pilih(dt, bakul) {
            dt.bakul = bakul
            if (bakul == 0) {
                dt.amaun_bayar = dt.amaun
            }
            this.$zcomm.store('butiran.bakul', dt)
                .then(res => {
                    this.form.check_amaun = 1
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                    }
                    if (bakul == 1) {
                        this.$zutil.notify("Data Berjaya Ditambahkan.")
                    } else {
                        this.$zutil.notify("Data Berjaya Dipadamkan.")
                    }
                    this.total()

                })
                .finally(() => {

                });
            this.total()
        },

        pilihCaraTerima(id) {
            this.form.lkp_cara_terima_id = id
            this.total()
        },
        getDaerah() {
            this.$zcomm.get('daerah', {})
                .then(res => {
                    this.daerah = res
                })
        },
        getMukim() {
            this.$zcomm.get('mukim', {})
                .then(res => {
                    this.mukim = res
                })
        },
        getHmJenis() {
            this.$zcomm.get('hm_jenis', {})
                .then(res => {
                    this.hmJenis = res
                })
        }


    },
    mounted() {
        // override default setting

        this.total()
        this.getDaerah()
        this.getHmJenis()
        this.getMukim()
        this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.no_rujukan) {
            this.no_rujukan = this.cari.no_rujukan

            this.carian(0);
        }
        if (this.cari.success) {
            this.$zutil.notify("Data Berjaya Simpan.")
        }
        if (this.cari.errors) {
            this.errors = this.cari.errors
        }
        if (this.auth.user.id) {
            this.data_profil = this.profil
            if (this.data_profil && !(this.data_profil.emel && this.data_profil.no_tel)) {
                // alert('asd');
                this.$inertia.visit(this.$route('landing.profil') + '?cek_pay=1')
            }
        }
    }
}
</script>
<style type="text/css">.pkn-carian-landing {
    position: inherit !important;
}

.navbar {
    background-color: transparent;
}</style>

